// Registers the VetForge service worker (production only) with update detection
// and stale-chunk recovery. Never registers in dev (would cache the dev bundle).

let refreshing = false;

function onControllerChange() {
  // A new service worker took control — reload once to pick up fresh assets.
  if (refreshing) return;
  refreshing = true;
  window.location.reload();
}

export function registerServiceWorker() {
  if (process.env.NODE_ENV !== "production") return;
  if (!("serviceWorker" in navigator)) return;

  window.addEventListener("load", () => {
    navigator.serviceWorker
      .register("/sw.js")
      .then((registration) => {
        navigator.serviceWorker.addEventListener("controllerchange", onControllerChange);

        // If a new worker is already waiting (came from another tab), prompt now.
        if (registration.waiting) {
          notifyUpdate(registration);
        }

        registration.addEventListener("updatefound", () => {
          const worker = registration.installing;
          if (!worker) return;
          worker.addEventListener("statechange", () => {
            if (worker.state === "installed" && navigator.serviceWorker.controller) {
              notifyUpdate(registration);
            }
          });
        });
      })
      .catch(() => {
        // Registration failure is non-fatal — the app still works online.
      });
  });
}

let updateListener = null;
function notifyUpdate(registration) {
  if (updateListener) updateListener({ waitingWorker: registration.waiting });
}

export function onServiceWorkerUpdate(cb) {
  updateListener = cb;
}

// Activate a waiting worker (user tapped "Update").
export function applyServiceWorkerUpdate(waitingWorker) {
  if (waitingWorker) {
    waitingWorker.postMessage({ type: "SKIP_WAITING" });
  }
}

// Stale-chunk recovery: if a code-split chunk 404s (old index cached, new deploy
// live), force one reload to fetch the fresh build. Guarded against loops.
export function installChunkErrorRecovery() {
  window.addEventListener(
    "error",
    (event) => {
      const msg = event.message || "";
      const isChunkError =
        /Loading chunk [\w-]+ failed/i.test(msg) ||
        /ChunkLoadError/i.test(msg) ||
        /Failed to fetch dynamically imported module/i.test(msg);
      if (!isChunkError) return;
      if (sessionStorage.getItem("vf-chunk-reloaded")) return;
      sessionStorage.setItem("vf-chunk-reloaded", "1");
      window.location.reload();
    },
    true
  );
  // Clear the loop guard once the page has been healthy for a while.
  window.addEventListener("load", () => {
    setTimeout(() => sessionStorage.removeItem("vf-chunk-reloaded"), 10_000);
  });
}
